import { render, staticRenderFns } from "./UserDetail.vue?vue&type=template&id=31c57b9e&scoped=true"
import script from "./UserDetail.vue?vue&type=script&lang=js"
export * from "./UserDetail.vue?vue&type=script&lang=js"
import style1 from "./UserDetail.vue?vue&type=style&index=1&id=31c57b9e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c57b9e",
  null
  
)

export default component.exports